import { FormattedMessage } from 'react-intl';
import { cn } from '@/helpers/classnames';
import { periodStatusMessages } from '@/helpers/periodStatus';
import type { PeriodStatus } from '@/helpers/periodStatus';

const statusColors: Record<PeriodStatus, string> = {
  upcoming: 'bg-blue-100 text-blue-800',
  active: 'bg-green-100 text-green-800',
  past: 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300',
};

interface PeriodStatusBadgeProps {
  status: PeriodStatus;
}

export const PeriodStatusBadge = ({ status }: PeriodStatusBadgeProps) => (
  <span
    className={cn(
      'inline-flex w-fit rounded-full px-2 py-0.5 text-sm font-medium',
      statusColors[status],
    )}
  >
    <FormattedMessage {...periodStatusMessages[status]} />
  </span>
);
